var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_2386)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87269 9.00001C3.87269 8.42841 3.96763 7.88041 4.13707 7.36641L1.17126 5.10161C0.59324 6.27521 0.267578 7.59761 0.267578 9.00001C0.267578 10.4012 0.592839 11.7228 1.17006 12.8956L4.13426 10.6264C3.96642 10.1148 3.87269 9.56881 3.87269 9.00001Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07972 3.80001C10.3215 3.80001 11.4431 4.24001 12.3243 4.96001L14.888 2.40001C13.3257 1.04001 11.3229 0.200012 9.07972 0.200012C5.59718 0.200012 2.60413 2.19161 1.1709 5.10161L4.13671 7.36641C4.82007 5.29201 6.76804 3.80001 9.07972 3.80001Z",
    fill: "#EB4335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07972 14.2C6.76804 14.2 4.82007 12.708 4.13671 10.6336L1.1709 12.898C2.60413 15.8084 5.59718 17.8 9.07972 17.8C11.2292 17.8 13.2813 17.0368 14.8215 15.6068L12.0063 13.4304C11.2119 13.9308 10.2117 14.2 9.07972 14.2Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.492 9.00001C17.492 8.48001 17.4119 7.92001 17.2917 7.40001H9.08008V10.8H13.8068C13.5704 11.9592 12.9271 12.8504 12.0066 13.4304L14.8218 15.6068C16.4397 14.1052 17.492 11.8684 17.492 9.00001Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_2386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/Google-icon.0a0c8de35731cd6b10b318231621543f.svg";
export { ForwardRef as ReactComponent };